import type { CRM } from '@/features/crm/types';

export type CrmRequirableField =
  | 'firstName'
  | 'lastName'
  | 'initials'
  | 'address.street'
  | 'address.housenr'
  | 'address.zipcode'
  | 'address.city';

export const REQUIRED_FIELDS_BY_CRM: Partial<
  Record<CRM, Array<CrmRequirableField>>
> = {
  brio: [
    'address.street',
    'address.housenr',
    'address.zipcode',
    'address.city',
  ],
  dias: ['address.street', 'address.housenr', 'address.city'],
};

export const FIELDS_REQUIRED_BY_ANY_CRM = [
  ...new Set(Object.values(REQUIRED_FIELDS_BY_CRM).flat()),
];
